export default "__VITE_ASSET__D9Og$6Ie__"